<template>
  <div class="d-flex full-width py-5">
    <div class="align-center d-flex flex-3">
      <div class="divider-line"></div>
    </div>
    <div class="color-gainsboro text-center px-2">OR</div>
    <div class="align-center d-flex flex-3">
      <div class="divider-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrDivider"
};
</script>

<style scoped>
.divider-line {
  width: 100%;
  height: 1rem;
  position: relative;
}

.divider-line:before {
  content: "";
  position: absolute;
  border-bottom: 1px var(--color-gainsboro) solid;
  height: 100%;
  width: 100%;
  transform: translateY(-50%);
}
.flex-3 {
  flex: 3;
}
</style>
